import SignupMethods from './SignupMethods'

export default SignupMethods
